<template>
  <div>
    <HeroImage v-if="entry.image[0]" :image="entry.image[0]">
      <div class="container flex items-center h-full">
        <BarText tag="h1" :text="entry.textOverlay" class="flow-root fluid-4xl leading-none" />
      </div>
    </HeroImage>
    <ContentBlocks :entry="entry" />
  </div>
</template>
<script>
import gql from 'graphql-tag';
import HeroImage from '@/components/common/HeroImage';
import BarText from '@/components/BarText';
import ContentBlocks from '@/components/common/ContentBlocks';
import { ContentBlocksMatrixFragment } from '@/components/common/ContentBlocksMatrixFragment.js';

export const AboutPageFragment = gql`
  fragment AboutPageFragment on aboutPage_Entry {
    textOverlay
    image {
      ...CraftAssetFragment
    }
    contentBlocks {
      ...ContentBlocksMatrixFragment
    }
  }
  ${ContentBlocksMatrixFragment}
`;

export default defineNuxtComponent({
  name: 'AboutPage',
  components: { HeroImage, BarText, ContentBlocks },
  props: {
    entry: {
      type: Object,
      required: true,
    },
  },
});
</script>
